const base = {
  'c.HeadTooBar.slogan': '优质配件，全球一站式采购',
  'c.HeadTooBar.modifyPassword': '修改密码',
  'c.HeadTooBar.logout': '退出',
  'c.HeadTooBar.signUp': '注册',
  'c.HeadTooBar.login': '登录',
  'c.HeadTooBar.helpCenter': '帮助中心',

  'base.button.login': '去登录',
  'base.button.ok': '确定',
  'base.message.pleaseLogin': '登录后可访问',

  'base.language': '语言',
  'base.countryorregion': '国家/地区',
  'base.currency': '币种',
  'base.currency.placeholder': '请选择币种',

  'base.noData': '暂无数据',
  'base.OE': 'OE',

  'menu.home': '首页',
  'menu.product': '配件目录',
  copyright: 'Copyright © 2015-现在 CassTime. 版权所有：深圳开思时代科技有限公司',

  'home.vehicleBrandTitle': '{vehicleBrand}配件亮点介绍',
  'home.AccessoriesClassification': '配件分类',
  'home.comingSoon': '敬请期待',

  'productList.total': '已为你查询到{total}条结果',
  'productList.priceTips': '*当前展示价格为EXW参考价，实际成交价可能会根据订购数量浮动',
  'productList.loginToView': '登录查看',
  'productList.circulationRating': '流通评分',
  'productList.filter.oe.placeholder': 'OE号或配件名称',
  'productList.contactUs': '联系我们',
  'productList.addToList': '加入清单',
  'productList.removeList': '移除清单',
  'productList.contactUs.web': '网页版',
  'productList.contactUs.template': '你好，我想了解下这个产品：',
  'productList.applicableVehicleTypes': '适用车型',
  'productList.approximately': '约',

  'pagination.total': '共 {total} 条',

  'base.message.apiError': '系统繁忙！请稍后重试。',

  'base.remark': '备注',
  'base.remark.placeholder': '请输入备注信息',
  'base.remark.maxLength': '备注不能超过{total}个字符',

  'base.copy': '复制',
  'base.copied': '已复制',

  'page.title.addressList': '地址管理',
  'page.title.orderList': '订单管理',
  'page.title.orderDetails': '订单详情',
  'page.title.orderConfirmation': '订单确认',

  'base.noLogin.getInfoError': '获取用户信息失败，请刷新页面重试',
  'base.api.error': '系统繁忙！请稍后重试。',

  'base.creator': '创建人',
  'base.createdDate': '创建时间',
  'base.operation': '操作',
  'base.detail': '详情',

  'base.attachment': '附件',
  'base.form.checkForm': '请检查表单内容',
  'base.index': '序号',
  'base.status': '状态',
  'base.quantity': '数量',

  'base.HeadTooBar.getUserInfoFailed': '获取用户信息失败, 请重新登录',

  Search: '搜索',
  Action: '操作',
  Delivery: '发货',
  total_days: '{total} 天',
  Item: '项',
  Price_currency: '价格 ({currency})',

  total_Parts: '{total} 件',
  total_parts: '{total} 件',
  Show_all: '显示全部',
  Collapse: '折叠',
  Part_name: '零件名称',
  Brand: '品牌',
  Part_number: '零件编号',
  Description: '描述',
  loading: '加载中...',
};

export default base;
